import PropTypes from 'prop-types'

import AddIcon from '@mui/icons-material/Add'

import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'

import BrandButton from '../../../subcomponents/brand/BrandButton'

// AddItemButton renders a button or icon button to add a new item to a list array.
const AddItemButton = props => {
  const { path, insertIndex, label, className, iconOnly, onAddItem } = props

  const handleClick = event => {
    event.stopPropagation()
    onAddItem(path, insertIndex)
  }

  return (
    <>
      {iconOnly ? (
        <Tooltip arrow title={label}>
          <IconButton aria-label={label} size="small" className={className} onClick={handleClick}>
            <AddIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      ) : (
        <BrandButton className={className} variant="outlined" startIcon={<AddIcon />} onClick={handleClick}>
          {label}
        </BrandButton>
      )}
    </>
  )
}

AddItemButton.propTypes = {
  path: PropTypes.array.isRequired, // Path array to the current item's location.
  insertIndex: PropTypes.number, // Optional index where the new item should be inserted.
  label: PropTypes.string.isRequired, // Label to display on the button or tooltip.
  className: PropTypes.string, // Optional CSS class.
  iconOnly: PropTypes.bool, // If true, renders as an icon instead of an outlined button.
  onAddItem: PropTypes.func.isRequired // Callback triggered when adding an item.
}

export default AddItemButton
